// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>9</span>&nbsp;&nbsp;For the sake of the house of the Lord our God,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;I will seek to do you good.<br> </p> </div></div>";
// Exports
module.exports = code;